<!-- eslint-disable -->
<template lang="pug">
    .preview-box
        .preview-box__column.preview-box__column--left
            .profile(:class="{'profile--green': !isUserPreview}")
                slot(name="left")
        .preview-box__column
            .info
                slot(name="right")
        slot
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            isUserPreview: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .preview-box {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;
        height: 100%;
        background-color: $x-color-white;
        box-sizing: border-box;
        @include media($sm) {
            padding: 15px;
            border-radius: $border-radius-40;
        }
        @include media($xlg) {
            flex-wrap: nowrap;
        }
    }

    .preview-box__column {
        padding: 0;
        width: 100%;
        @include media($sm) {
            padding: 15px;
        }
    }

    .preview-box__column--left {
        @include media($xlg) {
            width: auto;
            min-width: 370px;
        }
    }

    .profile {
        padding: 30px;
        box-sizing: border-box;
        border-radius: $border-radius-20;
        background-color: var(--user-main-color);
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .profile--green {
        background-color: $hsl-color-green-58;
    }
</style>
